export const getError = state => state.newAsset.error;
export const getLoading = state => state.newAsset.loading;



// WEBPACK FOOTER //
// ./src/selectors/newAssetSelectors.js